import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "modal"]
  
  open(event) {
    event.preventDefault()
    this.backdropTarget.classList.remove("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.add("opacity-100")
    this.modalTarget.classList.remove("opacity-0", "pointer-events-none")
    this.modalTarget.classList.add("opacity-100")
    document.body.classList.add("overflow-hidden")
  }
  
  close() {
    this.backdropTarget.classList.add("opacity-0", "pointer-events-none")
    this.backdropTarget.classList.remove("opacity-100")
    this.modalTarget.classList.add("opacity-0", "pointer-events-none")
    this.modalTarget.classList.remove("opacity-100")
    document.body.classList.remove("overflow-hidden")
  }
  
  confirm() {
    // Submit the hidden sign-out form
    const form = document.getElementById("signout-form")
    if (form) {
      form.requestSubmit()
    }
  }
}
